import { DisabledPrompt, Link, useStateManager } from '@bcm-dev/bcms-vite';
import { LayoutContainer, LeftColumnContainer, RightColumnContainer } from 'components/shared';
import React from 'react';
import { SVGAsset } from 'res';
import "./styles.css";

/**
 * @function MobileWirePayeesTable
 * @return {React.Component}
 * @exported true
 * @description The mobile table that shows the wire payees
 */

export default function MobileWirePayeesTable(props){
  const payees = props.payees ?? [];
  const payeeRows = payees.reduce((acc, payee) => {
    acc.push(<MobileWirePayeeRow key={ payee.id } payee={ payee } />);
    return acc;
  }, []);

  return(
    <div className="mobile-wire-payees-table">
      { payeeRows}
    </div>
  );
}

function MobileWirePayeeRow(props) {
  const { editPayee } = useStateManager();
  const payee = props.payee ?? {};

  return (
    <LayoutContainer>
        <LeftColumnContainer>
          <b>{ payee.nickname }</b>
          <div className="flex-container flex-horizontal align-center space-between">
            <p>Payee: </p><p className="text-right">{ payee.name }</p>
          </div>
          <div className="flex-container flex-horizontal align-center space-between">
            <p>Account Number: </p><p className="text-right">{ payee.account }</p>
          </div>
        </LeftColumnContainer>
        <RightColumnContainer>
          <div className="flex-container flex-horizontal align-center">
            <Link className="set-width" onClick={ editPayee(payee.id) }>
              <SVGAsset id="PencilIcon" />
            </Link>
            <DisabledPrompt>
              <SVGAsset className="set-width clickable" id="TrashcanXIcon" />
            </DisabledPrompt>
          </div>
        </RightColumnContainer>
      </LayoutContainer>
  );
}